var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bar-menu"
  }, [_c('el-menu', {
    staticClass: "vertical-menu",
    attrs: {
      "default-active": _vm.activeMark
    },
    on: {
      "select": _vm.goToPage
    }
  }, _vm._l(_vm.menuArr, function (item, index) {
    return _c('el-menu-item', {
      key: index,
      attrs: {
        "index": item.dataMark
      }
    }, [_c('i', {
      class: item.icon
    }), _c('span', {
      attrs: {
        "slot": "title",
        "title": _vm.$t(`lang.${item.name}`)
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.$t(`lang.${item.name}`)))])]);
  }), 1), _c('el-badge', {
    staticClass: "messageBox",
    attrs: {
      "value": _vm.messageNum,
      "hidden": !_vm.messageNum
    }
  }, [_c('span', {
    staticClass: "iconfont icon-a-mail2",
    attrs: {
      "title": _vm.$t('lang.TAlert')
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.goToPage('al');
      }
    }
  })])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }